import $ from 'jquery';
window.jQuery = window.$ = $;

import './parts/jquery.validate.min.js';
var visualizerConfig = {};
var tuxedoColors = {};
var debug = false;
const cookieId = 'pcaDv_20230524';

(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
ga('create', 'UA-2196934s8-1', 'auto');
ga('send', 'pageview');

$(function () {
    /* set cookie name for major/breaking changes
        update cookie name in: craft/templates/visualizer/_app/index.twig too */

    function resetDefaults(isReset) {

        // reset defaults
        if (isReset) {
            $('#dv').addClass('start'); // clicked start over btn
            // delete coookie on reset
            Cookies.remove(cookieId);
            log('cookie: deleted');

            visualizerConfig.handle = 'handle';
            visualizerConfig.isFrenchDoor = false;
            visualizerConfig.sidelightNum = 'screen';
            toggleEnclosureElements(true);
            $('.dv-frenchdoor-toggle').prop('checked', false);
            $('.layer-door.alt').remove();
        } else {
            $('#dv').removeClass('start'); // on pageload
        }

        $('.nav-drawer .nav-d-item.active, .toolbar-drawer.active').removeClass('active');
        drawer = $('.nav-drawer .nav-d-item:first').children('a').data('drawer');
        $dvArtboards.removeClass('active').first().addClass('active');
        $dvArtboardsMobile.removeClass('active').first().addClass('active');
        $('.get-started').removeAttr('style');
        setCookie("installation_contractor", "", -1);
        setCookie("homeowner_contractor", "", -1);
    }

    function saveCookie() {
        changeModalText();

        Cookies.set(cookieId, visualizerConfig, { expires: 7, path: '/' });
        log('cookie: saved');
    }

    function cloneDoor() {
        removeClone();
        var cloneDoor = $('.layer-door:first').clone().addClass('alt');
        cloneDoor.insertAfter('.layer-door:first');
        $('.layer-door:first').addClass('alt-l');
        $('.layer-door:last').removeClass('alt-l');
    }

    function removeClone() {
        $('.layer-door.alt').remove();
    }

    function updateScene() {
        // var  sceneSrc = '/assets/scenes/' + visualizerConfig.scene + '.jpg';
        temp = "";
        if(visualizerConfig.category == 'enclosure')
        {
            temp = '[data-shape="' + visualizerConfig.sunburstShape + '"]';
        }
        else
        {
            temp = '[data-scene="' + visualizerConfig.scene + '"]';
        }

        if($('.dv-switch-scene' + '.category-' + visualizerConfig.category + temp).length == 0)
        {
            $('.dv-switch-scene').removeClass('active');
            $('.dv-switch-scene.category-'+visualizerConfig.category+':first').addClass('active');
        }
        else
        {
            $('.dv-switch-scene').removeClass('active');
            $('.dv-switch-scene' + '.category-' + visualizerConfig.category + temp).addClass('active');
        }

        log('scene Updated');
        var sceneSrc = $('.dv-switch-scene.category-'+visualizerConfig.category+'.active:first').data('main-image');
        $('.layer-door:first').removeClass().addClass('absolute layer-door w-auto ' + visualizerConfig.scene + ' ' + visualizerConfig.category);
        $('.layer-handle:first').removeClass().addClass('absolute layer-handle ' + visualizerConfig.scene + ' ' + visualizerConfig.category);
        // $('.layer-scene').attr('src', sceneSrc);
        $('.layer-scene').css('background-image', "url('" + sceneSrc + "')");

        removeClone();
        // updateHandle();

        // is the selected scene an enclosure?
        if (visualizerConfig.category === 'enclosure') {
            toggleEnclosureElements(true);
            updateSunburst();
            updateSidelight();
        } else {
            toggleEnclosureElements(false);
        }
        if(typeof(retScene) !== "undefined" && retScene == "scene")
        {
            if(visualizerConfig.category == "entry")
            {
                visualizerConfig.isFrenchDoor = (visualizerConfig.handle == 'astragal' ? true : false);
            }
        }
        log("Do we want to clone ? " + visualizerConfig.isFrenchDoor);
        if (visualizerConfig.isFrenchDoor) {
            cloneDoor();
            $('.dv-frenchdoor-toggle').prop('checked', true);
        }else {
            $('.dv-frenchdoor-toggle').prop('checked', false);
            visualizerConfig.handle = "handle";
        }
        updateHandle();
        saveCookie();

    }

    function updateDoor() {

        // if active color is selected and door does not have color available, default to white
        if($.inArray(visualizerConfig.colorValue, visualizerConfig.swatches) == -1) {
            visualizerConfig.colorValue = 'wh';
            visualizerConfig.colorName = 'White';

            $('.dv-swatch.active').removeClass('active');
            $('.dv-swatch.wh').addClass('active');

            updateHandle();

        // if enclosure is active, update sunburst/sidelight with white
            if (visualizerConfig.category == 'enclosure') {
                updateSunburst();
                updateSidelight();
            }
        }

        var doorSrc = s3png + visualizerConfig.modelNum + visualizerConfig.doorView + visualizerConfig.colorValue + '.png';

        $('.layer-door:first').attr('src', doorSrc);
        $('.toggle-sister.active').removeClass('active');

        // is the selected scene french doors?
        if (visualizerConfig.isFrenchDoor) {
            $('.layer-door.alt:first').attr('src', doorSrc);

            if (visualizerConfig.category == 'enclosure') {
                $('.layer-door:first').addClass('alt-l');
            }
        } else {
            $('.layer-door.alt').remove();
        }

        // hide all swatches & sidelights on door selection then show avialable colors + sidelights
        $('.dv-swatch, .dv-sidelight').hide();
        if(typeof(visualizerConfig.swatches) !== "undefined")
        {
            for ( var i = 0, l = visualizerConfig.swatches.length; i < l; i++) {
                $('.dv-swatch.' + visualizerConfig.swatches[i]).show();
              //log( visualizerConfig.swatches[i] );
            }
        }

        if (visualizerConfig.sidelightsAvailable > 0) {
            $sidelights.hide();
            $('.dv-sidelight.sl-default').show();
            $('.dv-sidelight.sl-'+ visualizerConfig.modelNum).show();
        } else {
            $sidelights.hide();
            $('.dv-sidelight.sl-default').show();
        }

        if (visualizerConfig.hasSister) {
            $('.option-sister').show();
        } else {
            $('.option-sister').hide();
        }

        if (visualizerConfig.hasAirbrush) {
            $('.option-airbrush').show();
        } else {
            $('.option-airbrush').hide();
        }
        saveCookie();
    }

    function updateHandle() {
        // var colorSwatch = (visualizerConfig.colorValue == 'bw' ? 'wh' : visualizerConfig.colorValue);
        var colorSwatch = (typeof(tuxedoColors[visualizerConfig.colorValue]) !== "undefined" ? tuxedoColors[visualizerConfig.colorValue] : visualizerConfig.colorValue);
        var handleSrc = s3 + 'doors/' + visualizerConfig.handle + '_' + colorSwatch + '.png';
        var $handle = $('.layer-handle:first');

        if (visualizerConfig.isFrenchDoor) {
            $handle.addClass('astragal');
        } else {
            $handle.removeClass('astragal');
        }

        $handle.attr('src', handleSrc);
    }

    function updateSwatch() {
        toggleAirbrush();

        // is the selected scene an enclosure?
        if (visualizerConfig.category === 'enclosure') {
            updateSunburst();
            updateSidelight();
        }

        updateHandle();
        saveCookie();
    }

    function updateSunburst() {
        // var colorSwatch = (visualizerConfig.colorValue == 'bw' ? 'wh' : visualizerConfig.colorValue);
        var colorSwatch = (typeof(tuxedoColors[visualizerConfig.colorValue]) !== "undefined" ? tuxedoColors[visualizerConfig.colorValue] : visualizerConfig.colorValue);
        var sunburstSrc = s3 + 'sunburst/SB_' + visualizerConfig.sunburstShape + '_' + visualizerConfig.sunburstStyle + '_' + colorSwatch + '.png';
        $('.layer-sunburst').attr('src', sunburstSrc);
        $('.layer-sunburst').removeClass().addClass('absolute layer-sunburst ' + visualizerConfig.category + '-element ' + visualizerConfig.scene);
    }

    function updateSidelight() {
        var sidelightSrc = null;
        // var  colorSwatch = (visualizerConfig.colorValue == 'bw' ? 'wh' : visualizerConfig.colorValue);
        var colorSwatch = (typeof(tuxedoColors[visualizerConfig.colorValue]) !== "undefined" ? tuxedoColors[visualizerConfig.colorValue] : visualizerConfig.colorValue);

        removeClone();

        if (visualizerConfig.isFrenchDoor) {
            visualizerConfig.sidelightNum = 'frame';
            $('.sidelight-styles').hide();

            cloneDoor();
            // updateDoor();
        } else {
            if (visualizerConfig.sidelightNum == 'frame') {
                visualizerConfig.sidelightNum = 'screen';
            }
            $('.sidelight-styles').show();
        }

        if($('.dv-switch-scene.category-'+visualizerConfig.category+'.active').data('allow-sidelights') == "no")
        {
            $('.sidelights').addClass('hide');
        }
        else
        {
            sidelightSrc = s3 + 'sidelights/' + visualizerConfig.sidelightNum + '_straight_' + colorSwatch + '.png';
            $('.layer-sidelights').attr('src', sidelightSrc);
            $('.layer-sidelights').removeClass().addClass('absolute layer-sidelights ' + visualizerConfig.category + '-element ' + visualizerConfig.scene);
        }

    }

    function toggleAirbrush() {

        visualizerConfig.doorView = (visualizerConfig.airbrushState ? '_AB_straight_' : '_straight_');
        log('airbrushState: ' + visualizerConfig.airbrushState);

        var doorSrc = s3png + visualizerConfig.modelNum + visualizerConfig.doorView + visualizerConfig.colorValue + '.png';
        $('.layer-door').attr('src', doorSrc);
    }

    function toggleFlipDoor() {
        // switch models in config
        var newModelNum = visualizerConfig.sisterModel;
        var newSisterModel = visualizerConfig.modelNum;

        visualizerConfig.modelNum = newModelNum;
        visualizerConfig.sisterModel = newSisterModel;

        $('.dv-thumb.active').removeClass('active');
        $('.dv-thumb[data-model=' + visualizerConfig.modelNum + ']').addClass('active');

        var doorSrc = s3png + visualizerConfig.modelNum + visualizerConfig.doorView + visualizerConfig.colorValue + '.png';
        $('.layer-door').attr('src', doorSrc);

        log('flip door: ' + visualizerConfig.modelNum + ' => ' + visualizerConfig.sisterModel);

        saveCookie();
    }

    function toggleEnclosureElements(isEnclosure) {
        if (isEnclosure) {
            $('.enclosure-element').removeClass('hide');
            if (visualizerConfig.isFrenchDoor) {
                $('.sidelights').addClass('hide');
                $('.layer-sidelights').addClass('hide');
            }

        } else {
            $('.enclosure-element').addClass('hide');
        }

        if($('.dv-switch-scene.category-'+visualizerConfig.category+'.active').data('allow-sidelights') == "no")
        {
            $('.sidelights').addClass('hide');
            $('.layer-sidelights').addClass('hide');
        }

        if(($('.dv-switch-scene.category-'+visualizerConfig.category+'.active').data('handle') == "astragal" || visualizerConfig.category == 'enclosure') && visualizerConfig.category != 'entry')
        {
            log("French toggle activated.");
            $('.dv-frenchdoor-toggle').parents(".enclosure-element:first").removeClass('hide');
        }
        else
        {
            log("French toggle Hidden.");
            $('.dv-frenchdoor-toggle').parents(".enclosure-element:first").addClass('hide');
        }

    }

    $.urlParam = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        //log('param: ' + name + '|' + results);
        var hasResult = (results === null ? false : true);
        var paramVal = (results === null ? false : results[1]);
        return {has: hasResult, get: paramVal};
    }

    var $scenes = $('.dv-switch-scene');
    var $dvArtboards = $('#dv-artboards > div');
    var $dvArtboardsMobile = $('#dv-artboards-mobile > div');
    var $dvNavMain = $('.nav-drawer');
    var $sidelights = $('.dv-sidelight');

    var s3 = 'https://cf.pcaproducts.com/images/';
    var s3png = s3 + 'doors/png/';
    var doorToggle = 0;
    var drawer = 'scene';
    var prevDrawer = null;
    var sunburstThumbs = ["d3","d5","d7","b3","b5","b7","c3","c5","c7","screen"];

    // do we have cookies stored? If not, set the hash
    var visualizerSavedState = Cookies.getJSON(cookieId);

    if (!visualizerSavedState) {

        visualizerConfig = {
            "category": "entry",
            "modelName": "Westmore",
            "modelNum": "A-500",
            "colorName": 'White',
            "colorValue": "wh",
            "scene": "blue_door",
            "doorView": "_straight_",
            "handle": "handle",
            "isFrenchDoor": false,
            "sidelightNum": "screen",
            "sidelightsAvailable": 0,
            "sunburstStyle": "c5",
            "sunburstShape": "hm",
            "airbrushState": false, // airbrushed turned on
            "hasAirbrush": false, // does model have airbrush option
            "sisterModel": null, // sister product model #
            "hasSister": false, // does model have a sister product
            "swatches" : ["wh", "iv", "sa", "cl", "br"]
        };
        log('docReady cookie: none');

    } else {

        log('docReady cookie: loaded');
        visualizerConfig = visualizerSavedState;

    }

    // do we have a partial url string
    // var urlParams = new URLSearchParams(window.location.search); // IE/Edge doesn't support URLSearchParams

    var retScene = false;
    var temp = $.urlParam('return');
    if(temp.has && temp.get)
    {
        retScene = temp.get;
    }

    if (window.location.search != "" && window.location.search != "?return=scene") {
        log('query string(s) present');

        retScene = 'scene';
        var qsParam = $.urlParam('modelNum');
        visualizerConfig.modelNum = qsParam.get;
        log('set modelNum: ' + qsParam.get);

        // set defaults for other variables if present
        qsParam = $.urlParam('colorValue');
        if (qsParam.has) {
            visualizerConfig.colorValue = qsParam.get;
            log('set colorValue: ' + qsParam.get);
            visualizerConfig.colorName = $('.dv-swatch[data-color=' + visualizerConfig.colorValue + ']').attr('title');
            log('set colorName: ' + visualizerConfig.colorName);
        }

        qsParam = $.urlParam('category');
        if (qsParam.has) {
            visualizerConfig.category = qsParam.get;
            log('set category: ' + qsParam.get);
        }

        qsParam = $.urlParam('scene');
        if (qsParam.has) {
            visualizerConfig.scene = qsParam.get;
            log('set scene: ' + qsParam.get);
        }

        qsParam = $.urlParam('handle');
        if (qsParam.has) {
            visualizerConfig.handle = qsParam.get;
            log('set handle: ' + qsParam.get);
        }

        qsParam = $.urlParam('isFrenchDoor');
        if (qsParam.has) {
            var strToBool = (qsParam.get == 'true' ? true : false);
            visualizerConfig.isFrenchDoor = strToBool;
            log('set isFrenchDoor: ' + visualizerConfig.isFrenchDoor);
        }

        qsParam = $.urlParam('sunburstStyle');
        if (qsParam.has) {
            visualizerConfig.sunburstStyle = qsParam.get;
            log('set sunburstStyle: ' + qsParam.get);
        }

        qsParam = $.urlParam('sunburstShape');
        if (qsParam.has) {
            visualizerConfig.sunburstShape = qsParam.get;
            log('set sunburstShape: ' + qsParam.get);
        }

        qsParam = $.urlParam('sidelightNum');
        if (qsParam.has) {
            visualizerConfig.sidelightNum = qsParam.get;
            log('set sidelightNum: ' + qsParam.get);
        }

        qsParam = $.urlParam('doorView');
        if (qsParam.has) {
            visualizerConfig.doorView = qsParam.get;
            log('set doorView: ' + qsParam.get);
        }

        qsParam = $.urlParam('airbrushState');
        if (qsParam.has) {
            var strToBool = (qsParam.get == 'true' ? true : false);
            visualizerConfig.airbrushState = strToBool;
            log('set airbrushState: ' + visualizerConfig.airbrushState);
        }

        // if there is no such door, default to A-500
        if (!$('.dv-door[data-model=' + visualizerConfig.modelNum + ']').length > 0) {
            log(visualizerConfig)
            visualizerConfig.modelNum = 'A-500';
            log('invalid door. set A-500 as default');
        }

    }

    // On doc ready select the default door thumbnail + import settings
    var $docReadyActiveDoor = $('.dv-door[data-model=' + visualizerConfig.modelNum + ']');
    visualizerConfig.hasAirbrush = $docReadyActiveDoor.data('airbrush');
    visualizerConfig.airbrushState = (visualizerConfig.hasAirbrush ? visualizerConfig.airbrushState : false);
    visualizerConfig.doorView = (visualizerConfig.airbrushState ? '_AB_straight_' : '_straight_');
    visualizerConfig.swatches = $docReadyActiveDoor.data('swatches');
    visualizerConfig.sisterModel = $docReadyActiveDoor.data('sister');
    visualizerConfig.hasSister = (visualizerConfig.sisterModel == 'none' ? false : true);
    $docReadyActiveDoor.addClass('active');

    log('docReady category: ' + visualizerConfig.category);
    log('docReady doorView: ' + visualizerConfig.doorView);
    log('docReady isFrenchDoor: ' + visualizerConfig.isFrenchDoor);
    log('docReady hasAirbrush: ' + $docReadyActiveDoor.data('airbrush'));
    log('docReady airbrushState: ' + visualizerConfig.airbrushState);
    log('docReady sisterModel: ' + $docReadyActiveDoor.data('sister'));
    log('docReady hasSister: ' + visualizerConfig.hasSister);
    log('docReady swatches: ' + $docReadyActiveDoor.data('swatches'));
    log('docReady Handle: ' + visualizerConfig.handle);

    // hide all sidelights on view. then show default sidelights
    if($('#dv-layers').length)
    {

        $sidelights.hide();
        $('.dv-sidelight.sl-default').show();
        $('.dv-sidelight[data-sidelight=' + visualizerConfig.sidelightNum + ']').addClass('active');
        updateSidelight();

        // hide share link on iOS devices
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            $('#dv-share').hide();
        }

        // if (visualizerConfig.category === 'enclosure') {
        //  toggleEnclosureElements(true);
        //  updateSunburst();
        //  updateSidelight();
        // } else {
        //  toggleEnclosureElements(false);
        // }

        // if(visualizerConfig.category == "entry" || (typeof(retScene) !== "undefined" && retScene == "scene"))
        // {
        //  visualizerConfig.isFrenchDoor = (visualizerConfig.handle == 'astragal' ? true : false);
        // }
        // else
        // {
        //  visualizerConfig.isFrenchDoor = false;
        // }
        updateScene();
        updateDoor();
    }

    $(document).on('click', '.category-select', function(e){
        e.preventDefault();
        resetDefaults(false);

        visualizerConfig.category = $(this).data('category');

        if($('.dv-switch-scene.category-'+visualizerConfig.category+'.active').length == 0)
        {
            $('.dv-switch-scene').removeClass('active');
            $('.dv-switch-scene.category-'+visualizerConfig.category+':first').addClass('active');
        }

        visualizerConfig.scene = $('.dv-switch-scene.category-'+visualizerConfig.category+'.active').data('scene');

        if (visualizerConfig.category === 'enclosure') {
            toggleEnclosureElements(true);
        } else {
            toggleEnclosureElements(false);
        }

        if(visualizerConfig.category == "entry" || (typeof(retScene) !== "undefined" && retScene == "scene"))
        {
            visualizerConfig.isFrenchDoor = (visualizerConfig.handle == 'astragal' ? true : false);
        }
        else
        {
            // Commenting for now as it seems bug to me (mufi).
            // When we make some door frenchDoor, on refresh, it gets updated to single door due to this.
            // visualizerConfig.isFrenchDoor = false;
        }

        updateScene();
        updateDoor();

        $scenes.hide();
        $('.category-' + visualizerConfig.category).show();
        $dvArtboards.toggleClass('active');
        $('#start-screen-mobile').hide();

        $dvArtboardsMobile.addClass('active');
        $('.get-started').hide();
        $('.dv-toolbar-scene, .' + drawer).addClass('active').siblings().removeClass('active');

        $('.category-text').html($(this).find('span').html() + " Tools");
        $('.vfs-done').removeClass('hidden');
        $('header.header.vfs-hide').show();

        setTimeout(function() {
            $(".v-aside, .scenes-control").addClass('active');
            goUpOnMobile(500);
        }, 100);
        log('category updated: ' + visualizerConfig.category);

        addFaddedScrollEffect($(".fadded-scroll-effect"));
        addFaddedScrollEffect($(".fadded-scroll-effect-mobile"));
        addFaddedHorizontalScrollEffect($(".fadded-scroll-toolbar"));
    });

    $dvNavMain.on('click', 'a', function(e){
        e.preventDefault();

        prevDrawer = drawer;
        drawer = $(this).data('drawer');

        if(drawer == prevDrawer && $(window).width() > 767) {
            $('.nav-d-item').removeClass('active');
            // $('.dv-toolbar-' + drawer).removeClass('active');

            $dvArtboards.addClass('inactive');
            $dvArtboardsMobile.addClass('inactive');
            $(".v-aside, .scenes-control").removeClass('active');

            drawer = "";
        } else {
            $('.' + drawer).addClass('active').siblings().removeClass('active');
            $('.dv-toolbar-' + drawer).addClass('active').siblings().removeClass('active');

            $dvArtboards.removeClass('inactive');
            $dvArtboardsMobile.removeClass('inactive');
            $(".v-aside, .scenes-control").addClass('active');
        }

        $("#dv-layers").removeClass('partial-screen full-screen');

        addFaddedScrollEffect($(".fadded-scroll-effect"));
        addFaddedScrollEffect($(".fadded-scroll-effect-mobile"));
    });

    $('.dv-switch-scene').on('click', function(e){
        e.preventDefault();
        var $scene = $(this);

        $scene.addClass('active').siblings().removeClass('active');

        visualizerConfig.scene = $scene.data('scene');
        visualizerConfig.handle = $scene.data('handle');

        if(visualizerConfig.category == "entry")
        {
            visualizerConfig.isFrenchDoor = (visualizerConfig.handle == 'astragal' ? true : false);
        }
        else
        {
            visualizerConfig.isFrenchDoor = false;
        }

        if (visualizerConfig.category === 'enclosure') {
            visualizerConfig.sunburstShape = $scene.data('shape');

            var i; // loop through sunburst arry to update thumbnails to selected shape
            for (i = 0; i < sunburstThumbs.length; ++i) {
                var thumbSrc = s3 + 'sunburst/SB_' + visualizerConfig.sunburstShape + '_' + sunburstThumbs[i] + '.jpg';
                $('.sb-' + sunburstThumbs[i]).attr('src', thumbSrc);
            }
        }

        updateScene();

        setTimeout(function() {
            goUpOnMobile();
        }, 100);
    });

    $('.dv-door').on('click', function(){
        var $thumb = $(this);

        visualizerConfig.modelName = $thumb.data('name');
        visualizerConfig.modelNum = $thumb.data('model');
        visualizerConfig.hasAirbrush = $thumb.data('airbrush');
        visualizerConfig.sisterModel = $thumb.data('sister');
        visualizerConfig.hasSister = (visualizerConfig.sisterModel == 'none' ? false : true);
        visualizerConfig.sidelightsAvailable = $thumb.data('sidelights');
        visualizerConfig.swatches = $thumb.data('swatches');

        $('.dv-door.active').removeClass('active');
        $thumb.addClass('active');

        // clear to default settings on new door selection
        visualizerConfig.doorView = '_straight_';
        visualizerConfig.airbrushState = false;

        log('modelNum: ' + visualizerConfig.modelNum);
        log('hasAirbrush: ' + visualizerConfig.hasAirbrush);
        log('sisterModel: ' + visualizerConfig.sisterModel);
        log('hasSister: ' + visualizerConfig.hasSister);

        // $('.toggle-airbrush, .toggle-sister').removeClass('active');
        $('.toggle-airbrush, .toggle-sister').prop('checked', false);

        updateDoor();

        setTimeout(function() {
            goUpOnMobile();
        }, 100);
    });

    // Enclosure sunburst shape logic
    $('.dv-sunburst-shape').on('click', function(e){
        e.preventDefault();
        var $el = $(this);
        $el.addClass('active').siblings().removeClass('active');

        visualizerConfig.sunburstShape = $el.data('shape');

        updateSunburst();

        setTimeout(function() {
            goUpOnMobile();
        }, 100);
    });

    // Enclosure sunburst shape logic
    $('.dv-sunburst-style').on('click', function(e){
        e.preventDefault();
        var $el = $(this);
        $el.addClass('active').siblings().removeClass('active');

        visualizerConfig.sunburstStyle = $el.data('style');

        updateSunburst();
        saveCookie(); // saving cooking here since other functions call updateSunburst

        setTimeout(function() {
            goUpOnMobile();
        }, 100);
    });

    // Enclosure sidelight logic
    $('.dv-sidelight').on('click', function(e){
        e.preventDefault();
        var $el = $(this);
        visualizerConfig.sidelightNum = $el.data('sidelight');

        $el.addClass('active').siblings().removeClass('active');

        updateSidelight();
        saveCookie(); // saving cooking here since other functions call updateSidelight

        setTimeout(function() {
            goUpOnMobile();
        }, 100);
    });

    // toggle sidelights
    // $('.dv-frenchdoor-toggle').on('click', function(e){
    $(document).on('change', 'input.dv-frenchdoor-toggle', function(e) {
        e.preventDefault();
        $('input.dv-frenchdoor-toggle').prop('checked', $(this).prop('checked'));

        if($(this).prop('checked'))
        {
            visualizerConfig.isFrenchDoor = true;
            visualizerConfig.handle = 'astragal';
            $('.sidelights').addClass('hide');
            $('.layer-door:first').addClass('alt-l');

            if($('input.toggle-sister').prop('checked')) {
                $('input.toggle-sister').prop('checked', false);
                toggleFlipDoor();
            }
        }
        else
        {
            visualizerConfig.isFrenchDoor = false;
            visualizerConfig.handle = 'handle';
            if (visualizerConfig.sidelightNum == 'frame') {
                visualizerConfig.sidelightNum = 'screen';
            }

            $('.sidelights').removeClass('hide');
            $('.layer-door:first').removeClass('alt-l');
        }
        log('isFrenchDoor: ' + visualizerConfig.isFrenchDoor);

        updateHandle();
        updateSidelight();
        saveCookie(); // saving cooking here since other functions call updateSidelights

        setTimeout(function() {
            goUpOnMobile();
        }, 100);
    });

    // change door swatches on selection
    // https://stackoverflow.com/questions/7438990/jquery-callback-on-image-load-when-changing-the-src
    $('.dv-swatch').on('click', function(e){
        e.preventDefault();

        var $swatch = $(this);
        visualizerConfig.colorValue = $swatch.data('color');
        visualizerConfig.colorName = $swatch.attr('title');

        $swatch.addClass('active').siblings().removeClass('active');

        updateSwatch();

        setTimeout(function() {
            goUpOnMobile();
        }, 100);
    });

    $(document).on('change', '.dv_color', function(event) {
        event.preventDefault();
        /* Act on the event */
        visualizerConfig.colorValue = $(this).val();
        visualizerConfig.colorName = $(this).children('option:selected').text();
        $("#enc-color").text(visualizerConfig.colorName);
        saveCookie();

        setTimeout(function() {
            goUpOnMobile();
        }, 100);

    });

    // $('.toggle-airbrush').on('click', function(e){
    $(document).on('change', 'input.toggle-airbrush', function(e) {
        e.preventDefault();

        $('input.toggle-airbrush').prop('checked', $(this).prop('checked'));
        visualizerConfig.airbrushState = $(this).prop('checked');

        toggleAirbrush();
        saveCookie();

        setTimeout(function() {
            goUpOnMobile();
        }, 100);
    });

    // $('.toggle-sister').on('click', function(e){
    $(document).on('change', 'input.toggle-sister', function(e) {
        e.preventDefault();
        $('input.toggle-sister').prop('checked', $(this).prop('checked'));

        toggleFlipDoor();

        setTimeout(function() {
            goUpOnMobile();
        }, 100);
    });


    $('.toggle-share').on('click', function(e){
        // e.preventDefault();

        var share = $(this).data('toggle');
        $(this).addClass('active').siblings().removeClass('active');

        var shareUrl = getShareUrl();

        if (share == 'email') {
            var doorModel = visualizerConfig.modelNum;
                    doorModel = (visualizerConfig.airbrushState ? doorModel + ' AB' : doorModel);
            $('input[name="fields[doorModelHidden]"]').val(doorModel);
            $('input[name="fields[doorColorHidden]"]').val(visualizerConfig.colorName);
            $('textarea[name="fields[configurationUrl]"]').val(shareUrl);

            // override fields
            var sisterVal = (visualizerConfig.sisterModel == 'none' ? '' : visualizerConfig.sisterModel);
                sisterVal = (visualizerConfig.airbrushState ? sisterVal + ' AB' : sisterVal);
            var sunburstStyleVal = (visualizerConfig.category == 'enclosure' ? visualizerConfig.sunburstStyle : '');
            var sunburstShapeVal = (visualizerConfig.category == 'enclosure' ? visualizerConfig.sunburstShape : '');
            var sidelightVal = (visualizerConfig.isFrenchDoor || visualizerConfig.category == 'entry' ? '' : visualizerConfig.sidelightNum);
                sidelightVal = (sidelightVal == 'screen' ? 'Screen Only' : sidelightVal);
            var astragalVal = (visualizerConfig.isFrenchDoor ? 'Yes' : 'No');

            $('input[name="fields[sisterModel]"]').val(sisterVal);
            $('input[name="fields[sunburst]"]').val(sunburstStyleVal);
            $('input[name="fields[sunburstShape]"]').val(sunburstShapeVal);
            $('input[name="fields[sidelights]"]').val(sidelightVal);
            $('input[name="fields[frenchDoorAstragal]"]').val(astragalVal);

            log('send an email.');
        } else {
            $('#url-share').val(shareUrl);
        }

        $('#copy-link').on('click', function(e){
            e.preventDefault();

            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val(shareUrl).select();
            document.execCommand('copy');
            $temp.remove();
        });

    });

    // Jump back to start up screen
    $('.dv-reset').on('click', function(e) {
        e.preventDefault();
        resetDefaults(true);
    });

    if($('.popup-with-form').length)
    {
        /*$('.popup-with-form').magnificPopup({
            type: 'inline',
            preloader: false,
            // When elemened is focused, some mobile browsers in some cases zoom in
            // It looks not nice, so we disable it:
            callbacks: {
                beforeOpen: function() {
                    if($(window).width() < 700) {
                        this.st.focus = false;
                    } else {
                        this.st.focus = '#name';
                    }
                },
                close: function() {
                    $('.popup-with-form').removeClass('active');
                }
            }
        });*/
    }

    $('#print-drawing').on('click', function(){
        $('#print-target').print({
            title : 'PCA Approval Drawing',
            globalStyles : false,
            stylesheet : '/assets/css/print-drawing.css',
            rejectWindow : true,
            noPrintSelector : '.no-print',
            prepend : '<div style="margin-top:20px;text-align:center;"><img src="/assets/img/sprite/logo.png" width="100"><h1 class="title-border"> Approval Drawings</h1></div>'
        });
    });

    $(document).on('keyup', '.cfields', function(event) {
        let saveString = $(this).val().replace(/\n/g, ", ");
        setCookie($(this).attr('name'), saveString , 1);
    });

    $(document).on('click', '#download-btn', function(event) {
        log(getCookie("download_status"))
        if (getCookie("download_status") === 0)
        {
            event.preventDefault();
            return false;
        }
        else
        {
            $('.loader').show();
            $(this).addClass('pointer-none');
            setCookie('download_status', 0, 1);
            setTimeout(checkDownloadResponse, 500);
        }
    });

    $('form#enclosureEstimateForm-form').find('div.submit').prepend('<a href="/visualizer?return=scene" class="btn btn-outline btn-large">Go Back</a>')
    $('form#enclosureEstimateForm-form').find('div.submit').find('input[type="submit"]').addClass('set-right')

    if($('input.dealerEmail').length)
    {
        $('input.dealerEmail').parent().hide().prev().hide();
        $('input.dealerEmail').val($('input.dealerEmail').data('value'));
    }
    if($('input.dealerName').length)
    {
        $('input.dealerName').val($('input.dealerName').data('value').replace(/&nbsp;/g, " "));
    }

    // $('form#dealerEnclosureEstimateForm-form, form#enclosureEstimateForm-form').find('input[type="submit"]').wrap("<div class='on-right'></div>").before('<img src="/assets/img/loader.gif" class="loader" style="margin-right: 10px;">')
    // $('form#visualizerForm-form').find('input[type="submit"]').after('<img src="/assets/img/loader.gif" class="loader" style="margin-left: 10px;">')

    $(window).on('load', function () {
        $('form.js-validation').each(function(index, el) {
            $(this).find('textarea[name="g-recaptcha-response"]').addClass('required');
        });
    });

    $('form.js-validation').each(function(index, el) {
        $(this).find('input, textarea, select').each(function(index, el) {
            if(typeof($(this).attr('required')) !== "undefined")
            {
                $(this).removeAttr('required');
                $(this).addClass('required validate[required]');

                if($(this).attr('type') == "email")
                {
                    $(this).addClass('email');
                }
            }
        });

        $(this).find('textarea[name="g-recaptcha-response"]').addClass('required');

    });
    $('form.js-validation').validate(
    {
        rules:
        {
            "g-recaptcha-response":
            {
                required:function()
                {
                    if(grecaptcha.getResponse() == '')
                    {
                        return true;
                    }
                    else
                    {
                        return false;
                    }
                }
            }
        }, errorPlacement:function(error,element)
        {
            if(element.attr("type")=="checkbox")
            {
                error.appendTo(element.parent('label').parent());
            }
            else
            {
                error.insertAfter(element);
            }
        }
    });

    $(document).on('click', '.local-frenchdoor-toggle', function(event) {
        event.preventDefault();
        /* Act on the event */
        handlePreviewFrenchDoorToggle()
    });

    $(document).on('click', function(event) {
        if($(window).width() > 767) {
            if(! $(event.target).hasClass('.v-aside-icons') &&
                ! $(event.target).parents('.v-aside-icons:first').length &&
                ! $(event.target).hasClass('.v-aside') &&
                ! $(event.target).parents('.v-aside:first').length &&
                $(".v-aside").hasClass("active") &&
                typeof($(event.target).data('trigger')) === 'undefined'
            ) {
                $(".v-aside").removeClass('active');
                $('.nav-d-item').removeClass('active');
                drawer = '';
            }
        }

        if(! $(event.target).hasClass('.inner-toggle-menu') && ! $(event.target).parents('.inner-toggle-menu:first').length)
        {
            $('.inner-toggle-menu').next().slideUp(200);
        }

    });

    // window.open("/confirm/enclosure-estimate-thank-you/", "_blank");
    function handlePreviewFrenchDoorToggle(initial = false)
    {
        if(! initial)
        {
            $('.local-frenchdoor-toggle').toggleClass('active');
        }

        if($('.layer-scene').hasClass('category-entry'))
        {
            $('.local-frenchdoor-toggle').parent().addClass('hide');

            if($('.layer-scene').hasClass('entry-astragal'))
            {
                $('.local-frenchdoor-toggle').addClass('active');
            }
            else
            {
                $('.local-frenchdoor-toggle').removeClass('active');
            }

        }

        if($('.local-frenchdoor-toggle').hasClass('active'))
        {
            $('.layer-door').addClass('alt-l')
            cloneDoor();
            visualizerConfig.isFrenchDoor = true;
            visualizerConfig.handle = "astragal";
            // $('.layer-handle:first').addClass('astragal');
            setCookie('localFrenchDoor', 'true', 1);
            log('localFrenchDoor : true');
        }
        else
        {
            removeClone();
            $('.layer-door').removeClass('alt-l')
            // $('.layer-handle:first').removeClass('astragal');
            visualizerConfig.isFrenchDoor = false;
            visualizerConfig.handle = "handle";
            setCookie('localFrenchDoor', 'false', 1);
            log('localFrenchDoor : false');
        }
        updateHandle();
    }

    if($('.local-frenchdoor-toggle').length > 0)
    {
        handlePreviewFrenchDoorToggle(true);
    }

    if(typeof(visualizerConfig.category) !== "undefined" && retScene == "scene")
    {
        $('a.category-select[data-category="' + visualizerConfig.category + '"]').trigger('click');
    }

    /*if($('.drawer-items').length)
    {
        log('drawer-items exists');
        $('.drawer-items').mCustomScrollbar({
            documentTouchScroll: true
        });
    }*/

    log($('textarea[name="fields[configurationUrl]"]').length);
    if($('textarea[name="fields[configurationUrl]"]').length)
    {
        let sharableUrl = getShareUrl();
        $('textarea[name="fields[configurationUrl]"]').val(sharableUrl);
        $('body').attr('data-sharable_url', sharableUrl);
    }

    $(document).on('click', '.vfs-full-screen', function(event) {
        event.preventDefault();

        if($(this).hasClass('enabled')) {
            $(".vfs-hide").show();
            $(".vfs-remove-padding, .vfs-full-height").removeClass('enabled');
            $(this).removeClass('enabled');
        } else {
            $(".vfs-hide").hide();
            $(".vfs-remove-padding, .vfs-full-height").addClass('enabled');
            $(this).addClass('enabled');
        }

        addFaddedScrollEffect($(".fadded-scroll-effect-mobile"));
    });

    $(document).on('click', '.begin-app', function(event) {
        event.preventDefault();
        resetDefaults(false);

        $('.get-started').hide();
        // $("#tools-screen").removeClass("active");
        $("#start-screen-mobile").addClass("active");
        $('header.header.vfs-hide').hide();
        // $dvArtboards.toggleClass('active');

        // goUpOnMobile(300);
        // $('.category-select:first').click();
        // addFaddedScrollEffect($(".fadded-scroll-effect-mobile"));
    });

    $(document).on('click', '.v-prev, .v-next', function(event) {
        event.preventDefault();
        let aside = $(this).parents(".toolbar-drawer:first").data("aside");
        let found = false;

        if($(this).hasClass('en-category')) {
            $(".category-select[data-category='" + visualizerConfig.category + "']").click();
            goUpOnMobile(500);
            return;
        }

        if($(this).hasClass('v-prev')) {

            if(aside == "scene") {
                if($(window).width() > 767) {
                    return;
                }

                $dvArtboardsMobile.toggleClass('active');
                goUpOnMobile(500);
                $('.vfs-done.top-icon').addClass('hidden');
                return;
            }
            $('.nav-d-item.' + aside).prevAll().each(function(index, el) {
                if(! found && ! $(this).hasClass("hide")) {
                    found = $(this).children('a').data('drawer');
                    $(this).children('a').click();
                    goUpOnMobile(500);
                }
            });
        } else {
            $('.nav-d-item.' + aside).nextAll().each(function(index, el) {
                if(! found && ! $(this).hasClass("hide")) {
                    found = $(this).children('a').data('drawer');
                    $(this).children('a').click();
                    goUpOnMobile(500);
                }
            });
        }

        addFaddedScrollEffect($(".fadded-scroll-effect"));
        addFaddedScrollEffect($(".fadded-scroll-effect-mobile"));
    });

    $(document).on('click', '.vfs-edit', function(event) {
        event.preventDefault();
        $('.scenes-control').removeAttr('style');

        $(this).addClass('hidden');
        $(".vfs-done").removeClass('hidden');
        $('.scenes-control').removeClass('inactive').addClass('active');
        $('#dv-layers').removeClass('full-screen');

        goUpOnMobile(500);
        addFaddedScrollEffect($(".fadded-scroll-effect-mobile"));
    });

    $('.fadded-scroll-effect, .fadded-scroll-effect-mobile').each(function(a){
        let _this = $(this);
        addFaddedScrollEffect(_this);

        _this.scroll(function(event) {
            addFaddedScrollEffect(_this);
        });
    });

    $('.fadded-scroll-toolbar').each(function(a){
        let _this = $(this);
        addFaddedHorizontalScrollEffect(_this);

        _this.scroll(function(event) {
            addFaddedHorizontalScrollEffect(_this);
        });
    });

    /*$(document).scroll(function(event) {
        if($(window).width() > 767) {
            return;
        }

        if($(this).scrollTop() > 0) {
            $("#dv-artboards-mobile").removeClass("hidden");
            $("#dv-summary-mobile").addClass("hidden");

            $(".toggle-m-screen").addClass("active");
            $('.category-text').html($('.category-select[data-category="' + visualizerConfig.category + '"]').find('span').html() + " Tools");
        } else {
            $("#dv-artboards-mobile").addClass("hidden");
            $("#dv-summary-mobile").removeClass("hidden");

            $('.category-text').html(visualizerConfig.modelNum + " // " + visualizerConfig.colorName);
            $(".toggle-m-screen").removeClass("active");
        }
    });*/

    $(document).on('click', '.vfs-done', function(event) {
        event.preventDefault();

        /*$(this).addClass('hidden');
        $(".vfs-edit").removeClass('hidden');
        $('.scenes-control').addClass('inactive');
        $('#dv-layers').addClass('full-screen');

        setTimeout(function() {
            $("#tools-screen > div").removeClass('active');
            $("#tools-screen > div#v-tools").addClass('active');

            $('html, body').animate({
                scrollTop: $('body').offset().top
            }, '10');
        }, 300);*/

        if($("#dv-layers").hasClass("full-screen")) {
            $("#dv-layers").removeClass('full-screen partial-screen');
            $(".vfs-edit").addClass('hidden');
            $(this).removeClass('hidden');
        } else {
            /*$("#tools-screen > div").removeClass('active');
            $("#tools-screen > div#v-tools").addClass('active');*/
            $(".vfs-edit").removeClass('hidden');
            // $(this).addClass('hidden');

            $("#dv-layers").removeClass('partial-screen').addClass("full-screen");
        }

    });

    $(document).on('click', '.toggle-m-screen', function(event) {
        event.preventDefault();

        if($("#dv-layers").hasClass("partial-screen")) {
            $("#dv-layers").removeClass('partial-screen full-screen');
        } else {
            $("#dv-layers").removeClass('full-screen').addClass('partial-screen');
        }
        // goUpOnMobile($(this).hasClass("active") ? 0 : 500);
    });

    $(document).on('click', '.inner-toggle-menu', function(event) {
        event.preventDefault();
        $(this).next().slideToggle(200);
    });

    $(document).on('click', '.vfs-start-over', function(event) {
        event.preventDefault();
        $dvArtboards.toggleClass('active');
        $dvArtboardsMobile.removeClass('active');
        $('#start-screen-mobile').show();
        $('.scenes-control').removeClass('active');
        $('header.header.vfs-hide').hide();
        // goUpOnMobile(500);
        $('.vfs-done.top-icon').addClass('hidden');
    });

    $(document).on('click', '.vfs-show-toolbar', function(event) {
        event.preventDefault();
        $dvArtboardsMobile.removeClass('active').last().addClass('active');
        $("#tools-screen > div").removeClass('active');
        $("#tools-screen > div#v-tools").addClass('active');
    });
});

function changeModalText()
{
    $('.model-text').html(visualizerConfig.modelNum + " // " + visualizerConfig.colorName);
}

var checkDownloadResponse = function()
{
    if (getCookie("download_status") == 1)
    {
        $('.loader').hide();
        $('#download-btn').removeClass('pointer-none');
    }
    else
    {
        setTimeout(checkDownloadResponse, 500);
    }
}

function addFaddedScrollEffect(el) {
    const isScrollable = el.prop("scrollHeight") > el.prop("clientHeight");

    // GUARD: If element is not scrollable, remove all classes
    if (! isScrollable) {
        el.removeClass('is-bottom-overflowing is-top-overflowing');
        return;
    }

    // Otherwise, the element is overflowing!
    // Now we just need to find out which direction it is overflowing to (can be both)
    const isScrolledToBottom = el.prop("scrollHeight") <= el.prop("clientHeight") + el.prop("scrollTop") + 10;
    const isScrolledToTop = el.prop("scrollTop") === 0;

    if(isScrolledToBottom) {
        el.removeClass('is-bottom-overflowing');
    }else {
        el.addClass('is-bottom-overflowing');
    }

    if(isScrolledToTop) {
        el.removeClass('is-top-overflowing');
    }else {
        el.addClass('is-top-overflowing');
    }
}

function addFaddedHorizontalScrollEffect(el) {
    const isScrollable = el.prop("scrollWidth") > el.prop("clientWidth");
    // GUARD: If element is not scrollable, remove all classes
    if (! isScrollable) {
        el.removeClass('is-left-overflowing is-right-overflowing');
        return;
    }

    // Otherwise, the element is overflowing!
    // Now we just need to find out which direction it is overflowing to (can be both)
    const isScrolledToRight = el.prop("scrollWidth") <= el.prop("clientWidth") + el.prop("scrollLeft");
    const isScrolledToLeft = el.prop("scrollLeft") === 0;

    if(isScrolledToRight) {
        el.removeClass('is-right-overflowing');
    }else {
        el.addClass('is-right-overflowing');
    }

    if(isScrolledToLeft) {
        el.removeClass('is-left-overflowing');
    }else {
        el.addClass('is-left-overflowing');
    }
}

function getShareUrl()
{
    var shareParams = $.param(visualizerConfig).replace(/((?!^)\&swatches\%5B\%5D=)/g,'+');
        shareParams = shareParams.replace(/\+wh/, '&swatches=wh');

    if($('.pca-referrer-url').length)
    {
        // var urlOrigin = getCookie('referrer_url');
        var urlOrigin = $('.pca-referrer-url').text();
        var temp = urlOrigin.substring(0, urlOrigin.indexOf('refer=true&'));
        if(temp != "")
        {
            urlOrigin = temp;
        }
        if(urlOrigin.split("?").length == 1)
        {
            urlOrigin += "?";
        }
        else
        {
            if(urlOrigin.split("?")[1] != "")
            {
                urlOrigin += "&";
            }
        }
        urlOrigin += "refer=true&";
    }
    else
    {
        var urlOrigin = window.location.origin + '/visualizer?';
    }

    return urlOrigin + shareParams;
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function goUpOnMobile(offset = 0)
{
    if($(window).width() > 767) {
        return;
    }

    $('html, body').animate({
        scrollTop: $('body').offset().top + offset
    }, 'fast');
}

function log(data) {
    if(debug) {
        console.log(data)
    }
}
// end doc ready